import React from "react";
import DocumentDetail from "../common/DocumentDetail";
import { BLANK_PLACEHOLDER } from "config/constant";
import { MINUATES_OF_MEETING_FIELD as FIELD } from "config/documentConstant";
import { DocumentDtoWithAny } from "models/document/DocumentDtoWithAny";
import { Text, View } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import { styles } from "pages/document/work/detail/style";
import { sanitizeContent } from "utils/htmlTranslate";

interface MinutesOfMeetingDetailProps {
  documentData: DocumentDtoWithAny["documentData"];
}

const MinutesOfMeetingDetail = ({
  documentData,
}: MinutesOfMeetingDetailProps) => {
  const rows = [];
  for (let i = 0; i < documentData[FIELD.ATTENDEES.key].length; i += 2) {
    const first = documentData[FIELD.ATTENDEES.key][i];
    const second = documentData[FIELD.ATTENDEES.key][i + 1];
    rows.push([
      first?.affiliation || BLANK_PLACEHOLDER,
      first?.position || BLANK_PLACEHOLDER,
      first?.name || BLANK_PLACEHOLDER,
      second?.affiliation || BLANK_PLACEHOLDER,
      second?.position || BLANK_PLACEHOLDER,
      second?.name || BLANK_PLACEHOLDER,
    ]);
  }

  return (
    <>
      <DocumentDetail.Section>
        <DocumentDetail.Field label={FIELD.MEETING_DATE.label}>
          <DocumentDetail.Value.Date>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              {documentData[FIELD.MEETING_DATE.key] || BLANK_PLACEHOLDER}
            </Text>
          </DocumentDetail.Value.Date>
        </DocumentDetail.Field>

        <DocumentDetail.Field label={FIELD.LOCATION.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.LOCATION.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field label={FIELD.PURPOSE.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.PURPOSE.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field
          label={FIELD.ATTENDEES.label}
          padding="0"
          boldTopBorder
        >
          <DocumentDetail.Table>
            {/* 헤더 */}
            <View style={headerStyle}>
              {["소속", "직급", "이름", "소속", "직급", "이름"].map((col) => (
                <View style={headerCellStyle} key={col}>
                  <Text
                    style={{
                      fontFamily: "Pretendard",
                      fontSize: "10pt",
                    }}
                  >
                    {col}
                  </Text>
                </View>
              ))}
            </View>
            {/* 데이터 */}
            {rows.map((row: any, ridx: number) => (
              <View
                style={{
                  ...rowStyle,
                  borderBottom:
                    ridx === rows.length - 1 ? "none" : rowStyle.borderBottom,
                }}
                key={ridx}
              >
                {row.map((cell: any, cidx: number) => (
                  <View style={cellStyle} key={cidx}>
                    <Text
                      style={{
                        fontFamily: "Pretendard",
                        fontSize: "10pt",
                      }}
                    >
                      {cell}
                    </Text>
                  </View>
                ))}
              </View>
            ))}
          </DocumentDetail.Table>
        </DocumentDetail.Field>

        <View
          style={{ display: "flex", flexDirection: "row", marginVertical: 10 }}
        >
          <Text
            style={{
              width: "30mm",
              fontFamily: "Pretendard",
              fontSize: "10pt",
              fontWeight: 700,
              marginTop: 4,
            }}
          >
            내용
          </Text>
          <View style={{ display: "flex", flex: 1, marginLeft: 11 }}>
            <Html stylesheet={styles}>
              {sanitizeContent(documentData.content) || BLANK_PLACEHOLDER}
            </Html>
          </View>
        </View>
      </DocumentDetail.Section>
    </>
  );
};

export default MinutesOfMeetingDetail;

const cellStyle = {
  flex: 1,
  paddingVertical: 16,
  paddingLeft: 20,
  fontSize: 10,
  fontFamily: "Pretendard",
};
const headerCellStyle = {
  ...cellStyle,
  borderBottom: "1pt solid #E5E7EB",
};
const rowStyle = {
  flexDirection: "row" as const,
  borderBottom: "1pt solid #E5E7EB",
  alignItems: "center" as const,
};
const headerStyle = {
  ...rowStyle,
  fontWeight: 600 as const,
};
